import { NSBNAuth, NSBNUserAPIResponses } from "../types";
export var parseBNRole = function (role) {
    if (role === NSBNAuth.BNRole.Admin) {
        return NSBNAuth.BNRole.Admin;
    }
    if (role === NSBNAuth.BNRole.User) {
        return NSBNAuth.BNRole.User;
    }
    throw new Error("Role could not be parsed. (" + role + ")");
};
export var parseCognitoGroupToBNRole = function (groups) {
    if (groups.includes(NSBNUserAPIResponses.CognitoBNGroups.Admin)) {
        return NSBNAuth.BNRole.Admin;
    }
    if (groups.includes(NSBNUserAPIResponses.CognitoBNGroups.User)) {
        return NSBNAuth.BNRole.User;
    }
    throw new Error("Cognito Role Groups could not be parsed. (" + groups.join(",") + ")");
};
//# sourceMappingURL=parseBNRole.js.map